import customAxios from "../../customAxios";
import { ADMIN_PAY_COMPANY_DEPOSITE } from "../../routes";

const payCompanyDeposite = async (_id: string, endAt: string): Promise<any> => {
  const thisUrl: string = ADMIN_PAY_COMPANY_DEPOSITE + "/" + _id + `?endAt=${endAt}T00:00:00.0Z`;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ ADMIN_GET_COMPANY_DEPOSITE: error });
  }
};

export default payCompanyDeposite;
